import { Component } from '@angular/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { AuthenticationService } from '../../../core/services/authentification.service';
import { APP_ROUTES } from '../../../core/constants/app-routes';
import { RouterLink } from '@angular/router';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

interface KpiCard {
  label: string;
  value: string;
}

@Component({
    selector: 'app-home-container',
    templateUrl: './home-container.component.html',
    styleUrls: ['./home-container.component.css'],
    imports: [RouterLink, FaIconComponent, TranslateModule]
})
export class HomeContainerComponent {
  readonly routes = APP_ROUTES;
  kpiCards: KpiCard[] = [
    { label: 'home.kpi.logements', value: 'common.dash' },
    { label: 'home.kpi.occupes', value: 'common.dash' },
    { label: 'home.kpi.impayes', value: 'common.dash' },
  ];

  constructor(
    private readonly authService: AuthenticationService,
    private readonly translate: TranslateService
  ) {}

  get greetingName(): string {
    return (
      this.authService.getUserFullName() ||
      this.translate.instant('home.welcome')
    );
  }
}
